import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { RESOLVER_GROUP_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import AddUsersToGroupDialog from "./AddUsersToGroupDialog";
import GroupsDialog from "./GroupsDialog";

function Groups() {

  const [groupsData, setGroupsData] = useState([]);

  useEffect(() => {
    getGroups();
  }, []);


  const getGroups = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(RESOLVER_GROUP_URL).then((response) =>
      setGroupsData(response.data.data)
    );
  };


  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <GroupsDialog
          groupId={0}
          selectedGroupName={""}
          callGroups={getGroups}
          isEdit={false}
        />
      </Box>

      <AppTableView
        rows={groupsData}
        cols={[
          {
            field: "name",
            headerName: "Group Name",
            flex: 1,
            renderCell: (params) => (
              <GroupsDialog
                groupId={params.row ?.id}
                selectedGroupName={params.row ?.name}
                callGroups={getGroups}
                isEdit={true}
              />
            ),
          },
          {
            field: "groupType.name",
            headerName: "Group Type",
            flex: 1,
            renderCell: (params) => params.row.groupType.name,
          },
          {
            field: "users",
            headerName: "Users",
            flex: 1,
            renderCell: (params) => (
              <AddUsersToGroupDialog
                groupId={params.row.id}
                selectedRoleName={params.row.name}
                selectedGroupName={params.row.name}
                callGroups={getGroups}
              />
            ),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}

export default Groups;
